import { Col, Row } from 'antd';
import React from 'react';

import { MdEmail } from "react-icons/md";

import "./NewFeedback.css";

function NewFeedback({title, description}) {
  return (
    <div className='new-feedback'>
      <Row justify="space-between" align="middle" className="new-container">
          <Col>
            <Row gutter={[24, 0]} align="middle">
              <Col>
                <h2>New</h2>
              </Col>
              <Col>
                <p className='title'>{title}</p>
                <p>
                  {description}
                </p>
              </Col>
            </Row>
          </Col>
          <Col>
            <button className="icon-btn">
              <MdEmail size={16} /> <span>Feed Back</span>{" "}
            </button>
          </Col>
        </Row>
    </div>
  )
}

export default NewFeedback;
